import { render, staticRenderFns } from "./editar.vue?vue&type=template&id=662cfe48&"
import script from "./editar.vue?vue&type=script&lang=js&"
export * from "./editar.vue?vue&type=script&lang=js&"
import style0 from "./editar.vue?vue&type=style&index=0&id=662cfe48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports